var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bulk-call-details" }, [
    _c(
      "div",
      { staticClass: "m-b-10 f-s-16" },
      [
        _c("i18n", {
          attrs: { path: "CALLS_SELECTED" },
          scopedSlots: _vm._u([
            {
              key: "numberOfCalls",
              fn: function() {
                return [
                  _vm._v(
                    "\n        " + _vm._s(_vm.selectedCalls.length) + "\n      "
                  )
                ]
              },
              proxy: true
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("table", { staticClass: "table_beauty bulk-call-details__table" }, [
      _c("thead", [
        _c("tr", { staticClass: "bg-widget" }, [
          _c("th", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "CAMPAIGN",
                expression: "'CAMPAIGN'"
              }
            ]
          }),
          _vm._v(" "),
          _c("th", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "PUBLISHER",
                expression: "'PUBLISHER'"
              }
            ]
          }),
          _vm._v(" "),
          _c("th", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "CALLER_ID",
                expression: "'CALLER_ID'"
              }
            ]
          }),
          _vm._v(" "),
          _c("th", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "DIALED_NUMBER",
                expression: "'DIALED_NUMBER'"
              }
            ]
          }),
          _vm._v(" "),
          _c("th", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "REVENUE",
                expression: "'REVENUE'"
              }
            ]
          }),
          _vm._v(" "),
          _c("th", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "PAYOUT",
                expression: "'PAYOUT'"
              }
            ]
          }),
          _vm._v(" "),
          _c("th")
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.selectedCalls, function(row) {
          return _c("tr", { key: row.id, staticClass: "bg-transparent" }, [
            _c("td", [
              _vm._v("\n          " + _vm._s(row.campaignName) + "\n        ")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v("\n          " + _vm._s(row.publisherName) + "\n        ")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n          " + _vm._s(row.inboundPhoneNumber) + "\n        "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v("\n          " + _vm._s(row.number) + "\n        ")
            ]),
            _vm._v(" "),
            _c("td", [
              row.conversionAmount
                ? _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("currency")(row.conversionAmount)) +
                        "\n          "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("td", [
              row.payoutAmount
                ? _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("currency")(row.payoutAmount)) +
                        "\n          "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("td", [
              _c(
                "a",
                {
                  staticClass: "btn btn-list-function",
                  on: {
                    click: function($event) {
                      return _vm.removeCall(row)
                    }
                  }
                },
                [
                  _c("i", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.right.hover",
                        value: {
                          text: _vm.$t("REMOVE_SELECTED_CALL"),
                          transition: 0
                        },
                        expression:
                          "{text:$t('REMOVE_SELECTED_CALL'), transition: 0}",
                        modifiers: { right: true, hover: true }
                      }
                    ],
                    staticClass: "typcn typcn-delete-outline",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }